import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Icon } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import Modal from 'components/Modal';
import PageTitle from 'components/PageTitle';
import ModalHeader from 'components/ModalHeader';
import Avatar from 'components/Avatar';
import Button from 'components/Button';

import { setToken } from 'api';

import { URLS } from 'config';
import { numberMask } from 'utilz';

import Answers from './components/Answers';

// eslint-disable-next-line
import 'antd/lib/icon/style/css';

import './styles.scss';
import containerActions from './actions';

class ProfilePage extends React.Component {
	state = { isOpen: true, answersOpen: false, isOpenConfirm: false }
	selectPayment = _type => () => {
	  this.setState((prevState) => {
	    const type = prevState.type === _type ? null : _type;
	    return { type };
	  });
	}

	backHandl = () => {
	  // eslint-disable-next-line
		this.props.history.goBack();
	}

  logoutHandl = () => {
    this.props.logout();
    this.props.resetStore(true);
    this.props.history.push(URLS.BASE);
    setToken();
  }

  toggleAnswerHandl = () => {
    this.setState(({ answersOpen }) => ({
      answersOpen: !answersOpen
    }));
  }

  lastRoute = (e) => {
    e.preventDefault();
    const lastRoute = localStorage.getItem('carsapp-route');
    const localStorageData = localStorage.getItem('carsapp') ? JSON.parse(localStorage.getItem('carsapp')) : null;

    if (localStorageData
        && localStorageData.user
        && localStorageData.user.user
        && !localStorageData.user.user.registrationDone) {
      this.props.getUserProgress((lastRouteServer) => {
        this.props.history.replace(lastRouteServer);
      });
    } else {
      this.props.history.replace(lastRoute || URLS.BASE);
    }
  }

  removeUserHandl = (e) => {
    e.preventDefault();

    this.props.removeUser();
  }

  toggleConfirmation = () => {
    this.setState(({ isOpenConfirm }) => ({
      isOpenConfirm: !isOpenConfirm
    }));
  }

  render() {
	  if (!Object.keys(this.props.user).length) {
	    return <Redirect to={URLS.LOGIN} />;
	  }
	  return (
  <React.Fragment>
    <Modal isOpen={this.state.isOpen}>
      <div className="page-profile">
        <div className="profile-fix">
          <ModalHeader backHandl={this.backHandl}>
            Profile
          </ModalHeader>

          <Avatar />
          <PageTitle>
            {this.props.user.userName || this.props.user.name || this.props.name || ''}
          </PageTitle>
          <p className={`profile-tell ${this.props.user.userName || this.props.user.name || this.props.name} ? '' : '-big'`}>
        +1 {numberMask(this.props.user.telephoneNumber)}
          </p>

          {
          !this.props.user.registrationDone ? (
            <Button
              onClick={this.lastRoute}
              disabled={false}
            >
                Continue where you left
            </Button>
          ) : null
        }
          <div className="profile-wrapper">
            {
            this.props.user.registrationDone &&
              <Link to={URLS.PAYMENT} className="profile-link">
                <Icon type="wallet" />
                  Account
                  <span> $200 </span>
              </Link>
            }
            <button
              className={`profile-link ${!this.props.user.registrationDone && '-disabled'}`}
              onClick={this.toggleAnswerHandl}
              disabled={!this.props.user.registrationDone}
            >
              <i className="ion-android-clipboard" />
            Answers
            </button>

            <Link
              to={URLS.SIGNATURE}
              className={`profile-link ${!this.props.user.registrationDone && '-disabled'}`}
              disabled={!this.props.user.registrationDone}
            >
              <Icon type="file" />
	          	Documents
            </Link>
            {/* <Link to={URLS.APPROVED} className="profile-link">
              <Icon type="setting" />
	        	Settings
            </Link> */}
            <button className="button-logout -remove" onClick={this.toggleConfirmation}>
              Delete my profile
            </button>
          </div>
        </div>

        <button className="button-logout" onClick={this.logoutHandl}>
	          	Sign out
        </button>
      </div>
    </Modal>
    <Answers
      isOpen={this.state.answersOpen}
      backHand={this.toggleAnswerHandl}
      user={this.props.user}
    />

    {
        this.state.isOpenConfirm ? (
          <div className={`confirmation-modal ${this.state.isOpenConfirm ? '-open' : ''}`}>
            <div className="confirmation-wrapper">
              <PageTitle>
          Delete your profile
              </PageTitle>
              <p className="confirmation-text">
        The profile will be permanently deleted.
              </p>

              <div className="confirmation-buttons">
                <button
                  onClick={this.toggleConfirmation}
                  className="confirmation-button -cancel"
                >
            Cancel
                </button>
                <button
                  onClick={this.removeUserHandl}
                  className="confirmation-button -delete"
                >
            Delete
                </button>
              </div>
            </div>
          </div>
        ) : <div />
      }
  </React.Fragment>
	  );
  }
}

ProfilePage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getUserProgress: PropTypes.func.isRequired,
  removeUser: PropTypes.func.isRequired,
  resetStore: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  user: state.user.user,
  name: state.name.name
});


export default connect(mapStateToProps, containerActions)(ProfilePage);



// WEBPACK FOOTER //
// ./src/pages/Profile/index.js